import { useMediaQuery } from '@mui/material';
import Router from 'Router/Router';
import MobileWarning from 'Components/MobileWarning';
import useConfig from 'hooks/useConfig';
import React, { FC } from 'react';

const App: FC = () => {
  const { minScreenWidth, minScreenHeight } = useConfig();
  const matchesMinScreenWidth = useMediaQuery(`(max-width:${minScreenWidth}px)`);
  const matchesMinScreenHeight = useMediaQuery(`(max-height:${minScreenHeight}px)`);

  return (
    <>
      <MobileWarning open={matchesMinScreenWidth || matchesMinScreenHeight} />
      <Router />
    </>
  );
};

export default App;
